/* Zoci cart page (sections/zoci-main-cart.liquid): quantity, remove, gift note, "Pairs well with" and one-tap Add,
   without reloading. Every change goes through /cart/change.js or /cart/add.js and the section is re-rendered from
   the response, so the page always shows exactly what Shopify holds. */
(function () {
  var root = function () { return document.querySelector('[data-zcp]'); };
  if (!root()) return;
  var sid = root().dataset.section;
  var busy = false;
  var noteTimer;

  function json(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); });
  }

  function setCount(n) {
    document.querySelectorAll('.cart-count').forEach(function (el) {
      el.innerHTML = el.classList.contains('cart-count-drawer') ? '(' + n + ')' : (n > 100 ? '~' : n);
    });
  }

  function swap(html) {
    var focusKey = document.activeElement && document.activeElement.dataset && document.activeElement.dataset.focus;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-zcp]');
    if (!fresh) { location.reload(); return; }
    root().replaceWith(fresh);
    if (focusKey) {
      var el = fresh.querySelector('[data-focus="' + focusKey + '"]');
      if (el && !el.disabled) el.focus();
      else { var t = fresh.querySelector('.zcp__title'); if (t) { t.tabIndex = -1; t.focus(); } }
    }
    loadRecs();
    watchBar();
  }

  function refresh() {
    return fetch(location.pathname + '?section_id=' + encodeURIComponent(sid))
      .then(function (r) { return r.text(); })
      .then(function (html) { swap(html); });
  }

  function change(item, qty) {
    if (busy) return;
    busy = true;
    var li = item.closest('[data-zcp-item]');
    li.classList.add('is-busy');
    json('/cart/change.js', { id: li.dataset.zcpItem, quantity: qty, sections: [sid], sections_url: location.pathname })
      .then(function (res) {
        if (!res.ok || res.d.status) {
          li.classList.remove('is-busy');
          var input = li.querySelector('[data-zcp-qty]');
          if (input) input.value = input.dataset.was;
          var err = li.querySelector('[data-zcp-error]');
          if (err) err.textContent = res.d.description || res.d.message || 'Could not update the bag, please try again.';
          return;
        }
        setCount(res.d.item_count);
        swap(res.d.sections[sid]);
      })
      .catch(function () { location.reload(); })
      .finally(function () { busy = false; });
  }

  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-zcp] [data-zcp-step]');
    if (step) {
      e.preventDefault();
      var input = step.closest('[data-zcp-item]').querySelector('[data-zcp-qty]');
      var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.dataset.zcpStep, 10));
      input.value = next;
      change(step, next);
      return;
    }
    var rm = e.target.closest('[data-zcp] [data-zcp-remove]');
    if (rm) { e.preventDefault(); change(rm, 0); }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-zcp] [data-zcp-qty]');
    if (!input) return;
    var v = parseInt(input.value, 10);
    if (isNaN(v) || v < 0) { input.value = input.dataset.was; return; }
    if (String(v) !== input.dataset.was) change(input, v);
  });

  /* Enter in a quantity box updates that line instead of submitting the form to checkout */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest('[data-zcp] [data-zcp-qty]');
    if (!input) return;
    e.preventDefault();
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('input', function (e) {
    var el = e.target.closest('[data-zcp] [data-zcp-note]');
    if (!el) return;
    var status = document.querySelector('[data-zcp-note-status]');
    if (status) status.textContent = '';
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () {
      json('/cart/update.js', { note: el.value }).then(function (res) {
        var s = document.querySelector('[data-zcp-note-status]');
        if (s) s.textContent = res.ok ? 'Saved' : 'Could not save, please try again';
      }).catch(function () {
        var s = document.querySelector('[data-zcp-note-status]');
        if (s) s.textContent = 'Could not save, please try again';
      });
    }, 600);
  });

  /* One-tap Add from "Pairs well with" and the empty-bag starters. Capture phase, so the theme's product-form
     (built for the drawer, which this page does not have) never sees the submit. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.closest || !form.closest('[data-zcp]') || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;
    e.preventDefault();
    e.stopPropagation();
    var idInput = form.querySelector('[name="id"]');
    var btn = form.querySelector('button[type="submit"], button[name="add"]');
    if (!idInput || (btn && btn.classList.contains('loading'))) return;
    if (btn) btn.classList.add('loading');
    json('/cart/add.js', { items: [{ id: Number(idInput.value), quantity: 1 }] })
      .then(function (res) {
        if (!res.ok) {
          if (btn) { btn.classList.remove('loading'); btn.textContent = 'Sold out'; btn.disabled = true; }
          return;
        }
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
          setCount(c.item_count);
          return refresh();
        });
      })
      .catch(function () { if (btn) btn.classList.remove('loading'); });
  }, true);

  function loadRecs() {
    var box = document.querySelector('[data-zcp-recs]');
    if (!box) return;
    fetch(box.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var wrap = new DOMParser().parseFromString(html, 'text/html').querySelector('.swiper-wrapper');
        var rail = box.querySelector('[data-zcp-rail]');
        if (!wrap || !wrap.children.length || !rail) return;
        rail.innerHTML = wrap.innerHTML;
        rail.querySelectorAll('input[name="id"][disabled]').forEach(function (i) { i.disabled = false; });
        box.hidden = false;
      })
      .catch(function () {});
  }
  /* Phone: a slim Total + Checkout bar while the summary card is off screen (the card is below the pieces there) */
  var io;
  function watchBar() {
    if (io) io.disconnect();
    var bar = document.querySelector('[data-zcp-bar]');
    var card = document.querySelector('.zcp__card');
    if (!bar || !card || !('IntersectionObserver' in window)) return;
    io = new IntersectionObserver(function (entries) {
      var off = !entries[0].isIntersecting && entries[0].boundingClientRect.top > 0;
      bar.classList.toggle('is-on', off);
    });
    io.observe(card);
  }

  loadRecs();
  watchBar();
})();
